import { cloned, toVarName, slugify } from '@/helpers'
import { RecordDef, is } from '@/models'
import { mapControl } from './control-mappers.js'

export function mapAllSections(meta) {
  /**
   * Maps all sections and returns the merged plain sections mapper
   * and a list of table mappers.
   * @returns: { plain: Mapper, tables: [Mapper, ...] } or Null
   */
  let plainMapper = { // only one Plain mapper must exist
    cols: [],
    attachments: [],
    photos: []
  }; 
    
  let tableMappers = []; // cero or more mappers

  (meta.sections || []).map((section) => {
    if (section.type === is.PLAIN_SECTION) {

      let mapped = mapSection(section);

      // PlainSections must be merged into one single Mapper
      let allcols = plainMapper.cols.concat(mapped.cols);
      plainMapper.cols = renameDuplicates(allcols);
      plainMapper.attachments = plainMapper.attachments.concat(mapped.attachments);
      plainMapper.photos = plainMapper.photos.concat(mapped.photos);
    }

    if (section.type === is.TABLE_SECTION) {
      // table sections must have one Mapper per section
      tableMappers.push(mapSection(section)); 
    }
  })

  return {
    plain: cloned(plainMapper),
    tables: cloned(tableMappers)
  }
}

function mapSection(section) {
  /**
   * Maps a given section to a Mapper object
   * @returns: a Mapper object or Null if not mapeable
   */
  if (section.type === is.isPARAGRAPH_SECTION) 
    return null;

  let prefix = section.type === is.PLAIN_SECTION ? 'plane' : 'table';

  let mapped = {
    type: prefix,
    key: section.property,
    label: section.label,
    name: slugify(section.label),
    cols: [],
    attachments: [],
    photos: []
  }
  
  let controls = section.controls || [];

  controls.map((control) => {
    // { key:"", label:"" , group: "cols, attachs, photos", map: {}}
    let mappedField = mapControl(prefix, control); // is null if not mappeable

    if (mappedField) mapped[mappedField.group].push(mappedField);
  });

  return mapped;
}

function renameDuplicates(cols) {
  let 
    hashed = {},
    counter = 1;

  let renameds = cols.map((t) => {
    if (hashed[t.name]) {
      // replace last 3 chars with a counter to avoid duplicates 
      t.name = slugify(t.name.substring(0, t.name.length-4)+'_'+(counter++));
    }
    hashed[t.name] = true;
    return t;
  })
  //console.log(hashed)

  return renameds;
}
